export enum UnspecifiedKeysEnum {
  UnspecifiedIndustryKey = 'Not Specified',
  UnspecifiedGenderKeyLong = 'UNS',
  UnspecifiedGenderKeyShort = 'U',
}
